import { render, staticRenderFns } from "./SendingEmailRecords.vue?vue&type=template&id=be423190&scoped=true"
import script from "./SendingEmailRecords.vue?vue&type=script&lang=js"
export * from "./SendingEmailRecords.vue?vue&type=script&lang=js"
import style0 from "./SendingEmailRecords.vue?vue&type=style&index=0&id=be423190&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be423190",
  null
  
)

export default component.exports